import { HttpResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';

import { NotificationService } from '../services/notification.service';

interface ApiResponse {
  message?: string;
}

export const successInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationService);
  const isMutation = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(req.method);

  return next(req).pipe(tap((event) => {
    if (!isMutation || !(event instanceof HttpResponse)) return;
    const message = (event.body as ApiResponse | null)?.message;
    if (message) notificationService.showSuccess(message);
  }));
};
